import type { RootState } from '@portal-types/store';

export const accountDocumentNumber = (state: RootState) => state.account.data?.documentNumber;
export const accountName = (state: RootState) => state.account.data?.name;
export const accountEmail = (state: RootState) => state.account.data?.email;
export const accountPersisted = (state: RootState) => state.account.persisted;
export const accountUserPortal = (state: RootState) => state.account.data?.userPortal || 'full';
export const accountUserDocuments = (state: RootState) => state.account.data?.userDocuments;
export const accountUserStatus = (state: RootState) => state.account.data?.status;
